import classes from "./Slideshow.module.css";
import default_image from "../../images/NEWFATSYLOGO.svg";
import { useEffect, useState } from "react";

const Slideshow = () => {
  const [offsetY, setOffsetY] = useState(0);

  const handleScroll = () => {
    setOffsetY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={classes.slideshowWrapper}>
      <div className={`slideshow_carousel ${classes.carouselMain}`}>
        <img
          src={default_image}
          alt="Main Logo"
          className={classes.mainLogo}
          style={{ transform: `translateY(${offsetY * 0.5}px)` }}
        />
      </div>
      
    </div>
  );
};

export default Slideshow;
